import React from 'react';
import styled from 'styled-components';

import { AddOrChangeTxnProvider } from '../context/AddOrChangeTxnProvider';
import AddOrChangeEnrollmentTxnForm from './AddOrChangeEnrollmentTxnForm';
import AddOrChangeEnrollmentTxnHeading from './AddOrChangeEnrollmentTxnHeading';

const StyledContainer = styled.div`
    table {
        tr {
            border-bottom: ${({ theme }) => `1px solid${theme.gray8}`};
            border-top: ${({ theme }) => `1px solid${theme.gray8}`};
        }
        tr:nth-child(odd) {
            background-color: ${({ theme }) => theme.white};
        }

        tr:nth-child(even) {
            background-color: ${({ theme }) => theme.gray11};
        }
    }
`;

const StyledDiv = styled.div`
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
`;

function AddOrChangeEnrollmentTxnContainer() {
    return (
        <AddOrChangeTxnProvider>
            <AddOrChangeEnrollmentTxnHeading />
            <StyledContainer className="add-change-txn-container">
                <StyledDiv>
                    <AddOrChangeEnrollmentTxnForm />
                </StyledDiv>
            </StyledContainer>
        </AddOrChangeTxnProvider>
    );
}

export default AddOrChangeEnrollmentTxnContainer;
